const WidgetName = 'unisphere.widget.genie';

const ChatRuntimeName = 'chat';
const chatRuntimeSettingsSchema = {
  type: 'object',
  properties: {
    schemaVersion: {
      type: 'literal',
      value: '1',
      optional: true
    },
    genieServerUrl: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    partnerId: {
      type: 'primitive',
      value: 'string'
    },
    kalturaServerURI: {
      type: 'primitive',
      value: 'string'
    },
    ks: {
      type: 'primitive',
      value: 'string'
    },
    uiconfId: {
      type: 'primitive',
      value: 'string'
    },
    analytics: {
      optional: true,
      type: 'object',
      properties: {
        enabled: {
          type: 'primitive',
          value: 'boolean',
          optional: true
        },
        serverUrl: {
          type: 'primitive',
          value: 'string'
        },
        appName: {
          type: 'primitive',
          value: 'string'
        },
        appVersion: {
          type: 'primitive',
          value: 'string'
        }
      }
    },
    getSourceUrl: {
      type: 'function',
      optional: true
    },
    customization: {
      type: 'object',
      optional: true,
      properties: {
        breadcrumb: {
          type: 'object',
          optional: true,
          properties: {
            root: {
              type: 'object',
              optional: true,
              properties: {
                url: {
                  type: 'primitive',
                  value: 'string'
                },
                label: {
                  type: 'primitive',
                  value: 'string'
                }
              }
            }
          }
        }
      }
    },
    shareUrl: {
      type: 'object',
      optional: true,
      properties: {
        queryParam: {
          type: 'primitive',
          value: 'string'
        },
        createUrl: {
          type: 'function'
        }
      }
    },
    integrations: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          type: {
            type: 'primitive',
            value: 'string'
          },
          quota: {
            type: 'primitive',
            value: 'number'
          },
          formId: {
            type: 'primitive',
            value: 'string'
          },
          blocker: {
            type: 'primitive',
            value: 'boolean'
          }
        }
      },
      optional: true
    },
    initialQuestion: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    branding: {
      type: 'object',
      properties: {
        kalturaLogo: {
          type: 'primitive',
          value: 'boolean',
          optional: true
        }
      },
      optional: true
    }
  }
};

const pageVisualSettingsSchema = {
  type: 'object',
  properties: {
    schemaVersion: {
      type: 'literal',
      value: '1',
      optional: true
    },
    scrollContainerElementSelector: {
      type: 'primitive',
      value: 'string',
      optional: true
    }
  }
};
const bannerVisualSettingsSchema = {
  type: 'object',
  properties: {
    schemaVersion: {
      type: 'literal',
      value: '1',
      optional: true
    },
    predefinedQuestions: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          text: {
            type: 'primitive',
            value: 'string'
          },
          label: {
            type: 'primitive',
            value: 'string'
          }
        }
      },
      optional: true
    }
  }
};
const popupVisualSettingsSchema = {
  type: 'object',
  properties: {
    schemaVersion: {
      type: 'literal',
      value: '1',
      optional: true
    },
    isTranslucent: {
      type: 'primitive',
      value: 'boolean',
      optional: true
    }
  }
};

const FlashcardsToolRuntimeName = 'flashcards-tool';
const flashcardsToolRuntimeSettingsSchema = {
  type: 'object',
  properties: {
    schemaVersion: {
      type: 'literal',
      value: '1',
      optional: true
    }
  }
};

const UnisphereToolStatusesSchema = {
  type: 'enum',
  values: ['loading', 'error', 'ready']
};

const genieAnswerVisualSettingsSchema = {
  type: 'object',
  properties: {
    status: UnisphereToolStatusesSchema,
    threadId: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    messageId: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    groupIndex: {
      type: 'primitive',
      value: 'number',
      optional: true
    },
    title: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    summary: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    keypoints: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          title: {
            type: 'primitive',
            value: 'string',
            optional: true
          },
          summary: {
            type: 'primitive',
            value: 'string',
            optional: true
          },
          citation: {
            type: 'object',
            optional: true,
            properties: {
              clips: {
                type: 'array',
                optional: true,
                items: {
                  type: 'object',
                  properties: {
                    end_time: {
                      type: 'primitive',
                      value: 'number',
                      optional: true
                    },
                    entry_id: {
                      type: 'primitive',
                      value: 'string',
                      optional: true
                    },
                    last_index: {
                      type: 'primitive',
                      value: 'number',
                      optional: true
                    },
                    type: {
                      type: 'or',
                      properties: [{
                        type: 'literal',
                        value: 'CAPTION'
                      }, {
                        type: 'literal',
                        value: 'OCR'
                      }, {
                        type: 'literal',
                        value: 'DOCUMENT'
                      }],
                      optional: true
                    },
                    start_index: {
                      type: 'primitive',
                      value: 'number',
                      optional: true
                    },
                    start_time: {
                      type: 'primitive',
                      value: 'number',
                      optional: true
                    },
                    thumbnail: {
                      type: 'primitive',
                      value: 'string',
                      optional: true
                    },
                    video_link: {
                      type: 'primitive',
                      value: 'string',
                      optional: true
                    },
                    title: {
                      type: 'primitive',
                      value: 'string',
                      optional: true
                    }
                  }
                }
              }
            }
          }
        }
      },
      optional: true
    },
    branding: {
      type: 'object',
      optional: true,
      properties: {
        isTranslucent: {
          type: 'primitive',
          value: 'boolean',
          optional: true
        }
      }
    }
  }
};

const FollowupsToolRuntimeName = 'followups-tool';
const followupsToolRuntimeSettingsSchema = {
  type: 'object',
  properties: {
    schemaVersion: {
      type: 'literal',
      value: '1',
      optional: true
    }
  }
};
const followupsToolRuntimeGenieAnswerVisualSettingsSchema = {
  type: 'object',
  properties: {
    status: UnisphereToolStatusesSchema,
    threadId: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    messageId: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    questions: {
      type: 'array',
      items: {
        type: 'primitive',
        value: 'string'
      },
      optional: true
    },
    groupIndex: {
      type: 'primitive',
      value: 'number',
      optional: true
    },
    branding: {
      type: 'object',
      optional: true,
      properties: {
        isTranslucent: {
          type: 'primitive',
          value: 'boolean',
          optional: true
        }
      }
    }
  }
};

const SourcesToolRuntimeName = 'sources-tool';
const sourcesToolRuntimeSettingsSchema = {
  type: 'object',
  properties: {
    schemaVersion: {
      type: 'literal',
      value: '1',
      optional: true
    }
  }
};
const sourcesToolRuntimeGenieAnswerVisualSettingsSchema = {
  type: 'object',
  properties: {
    status: UnisphereToolStatusesSchema,
    threadId: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    messageId: {
      type: 'primitive',
      value: 'string',
      optional: true
    },
    groupIndex: {
      type: 'primitive',
      value: 'number',
      optional: true
    },
    sources: {
      type: 'array',
      optional: true,
      items: {
        type: 'or',
        properties: [{
          type: 'object',
          properties: {
            type: {
              type: 'literal',
              value: 'video'
            },
            title: {
              type: 'primitive',
              value: 'string'
            },
            entry_id: {
              type: 'primitive',
              value: 'string'
            },
            duration: {
              type: 'primitive',
              value: 'number'
            },
            has_short: {
              type: 'primitive',
              value: 'boolean'
            }
          }
        }, {
          type: 'object',
          properties: {
            type: {
              type: 'literal',
              value: 'document'
            },
            title: {
              type: 'primitive',
              value: 'string'
            },
            entry_id: {
              type: 'primitive',
              value: 'string'
            },
            duration: {
              type: 'primitive',
              value: 'number',
              optional: true
            },
            has_short: {
              type: 'primitive',
              value: 'boolean'
            }
          }
        }]
      }
    },
    branding: {
      type: 'object',
      optional: true,
      properties: {
        isTranslucent: {
          type: 'primitive',
          value: 'boolean',
          optional: true
        }
      }
    }
  }
};

var AnswerTypeEnum;
(function (AnswerTypeEnum) {
  AnswerTypeEnum["Flashcards"] = "flashcards";
  AnswerTypeEnum["Markdown"] = "markdown";
})(AnswerTypeEnum || (AnswerTypeEnum = {}));
var KalturaApplicationTypes;
(function (KalturaApplicationTypes) {
  KalturaApplicationTypes[KalturaApplicationTypes["Genie"] = 23] = "Genie";
})(KalturaApplicationTypes || (KalturaApplicationTypes = {}));
var KavaEventTypes;
(function (KavaEventTypes) {
  KavaEventTypes[KavaEventTypes["ButtonClicked"] = 10002] = "ButtonClicked";
  KavaEventTypes[KavaEventTypes["PageLoad"] = 10003] = "PageLoad";
})(KavaEventTypes || (KavaEventTypes = {}));
var KavaButtonsTypes;
(function (KavaButtonsTypes) {
  KavaButtonsTypes[KavaButtonsTypes["Create"] = 1] = "Create";
  KavaButtonsTypes[KavaButtonsTypes["Filter"] = 2] = "Filter";
  KavaButtonsTypes[KavaButtonsTypes["Search"] = 3] = "Search";
  KavaButtonsTypes[KavaButtonsTypes["Export"] = 4] = "Export";
  KavaButtonsTypes[KavaButtonsTypes["Navigate"] = 5] = "Navigate";
  KavaButtonsTypes[KavaButtonsTypes["Schedule"] = 6] = "Schedule";
  KavaButtonsTypes[KavaButtonsTypes["Insert"] = 7] = "Insert";
  KavaButtonsTypes[KavaButtonsTypes["Choose"] = 8] = "Choose";
  KavaButtonsTypes[KavaButtonsTypes["Launch"] = 9] = "Launch";
  KavaButtonsTypes[KavaButtonsTypes["Open"] = 10] = "Open";
  KavaButtonsTypes[KavaButtonsTypes["Send"] = 11] = "Send";
  KavaButtonsTypes[KavaButtonsTypes["Invite"] = 12] = "Invite";
  KavaButtonsTypes[KavaButtonsTypes["Close"] = 13] = "Close";
  KavaButtonsTypes[KavaButtonsTypes["Save"] = 14] = "Save";
  KavaButtonsTypes[KavaButtonsTypes["Expand"] = 15] = "Expand";
  KavaButtonsTypes[KavaButtonsTypes["Collapse"] = 16] = "Collapse";
  KavaButtonsTypes[KavaButtonsTypes["Edit"] = 17] = "Edit";
  KavaButtonsTypes[KavaButtonsTypes["Delete"] = 18] = "Delete";
  KavaButtonsTypes[KavaButtonsTypes["Browse"] = 19] = "Browse";
  KavaButtonsTypes[KavaButtonsTypes["Load"] = 20] = "Load";
  KavaButtonsTypes[KavaButtonsTypes["Add"] = 21] = "Add";
  KavaButtonsTypes[KavaButtonsTypes["Menu"] = 22] = "Menu";
  KavaButtonsTypes[KavaButtonsTypes["Register"] = 23] = "Register";
  KavaButtonsTypes[KavaButtonsTypes["Login"] = 24] = "Login";
  KavaButtonsTypes[KavaButtonsTypes["Link"] = 25] = "Link";
  KavaButtonsTypes[KavaButtonsTypes["Toggle"] = 26] = "Toggle";
  KavaButtonsTypes[KavaButtonsTypes["Thumbnail"] = 27] = "Thumbnail";
  KavaButtonsTypes[KavaButtonsTypes["Download"] = 28] = "Download";
  KavaButtonsTypes[KavaButtonsTypes["Share"] = 29] = "Share";
})(KavaButtonsTypes || (KavaButtonsTypes = {}));
var KavaPageTypes;
(function (KavaPageTypes) {
  KavaPageTypes[KavaPageTypes["View"] = 1] = "View";
  KavaPageTypes[KavaPageTypes["Create"] = 2] = "Create";
  KavaPageTypes[KavaPageTypes["Edit"] = 3] = "Edit";
  KavaPageTypes[KavaPageTypes["Participate"] = 4] = "Participate";
  KavaPageTypes[KavaPageTypes["List"] = 5] = "List";
  KavaPageTypes[KavaPageTypes["Analytics"] = 6] = "Analytics";
  KavaPageTypes[KavaPageTypes["Admin"] = 7] = "Admin";
  KavaPageTypes[KavaPageTypes["Error"] = 8] = "Error";
  KavaPageTypes[KavaPageTypes["Login"] = 9] = "Login";
  KavaPageTypes[KavaPageTypes["Registration"] = 10] = "Registration";
  KavaPageTypes[KavaPageTypes["Custom"] = 11] = "Custom";
})(KavaPageTypes || (KavaPageTypes = {}));

export { AnswerTypeEnum, ChatRuntimeName, FlashcardsToolRuntimeName, FollowupsToolRuntimeName, KalturaApplicationTypes, KavaButtonsTypes, KavaEventTypes, KavaPageTypes, SourcesToolRuntimeName, UnisphereToolStatusesSchema, WidgetName, bannerVisualSettingsSchema, chatRuntimeSettingsSchema, flashcardsToolRuntimeSettingsSchema, followupsToolRuntimeGenieAnswerVisualSettingsSchema, followupsToolRuntimeSettingsSchema, genieAnswerVisualSettingsSchema, pageVisualSettingsSchema, popupVisualSettingsSchema, sourcesToolRuntimeGenieAnswerVisualSettingsSchema, sourcesToolRuntimeSettingsSchema };
